"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderTest = void 0;
const Utilities_1 = require("../../../../TdWebtoolkitControls/javascript/Utilities");
let markup = require("./notification_tests.tmpl.htm");
function renderTest() {
    require.ensure(["./notification_tests.tmpl.less"], function (require) {
        require("./notification_tests.tmpl.less");
        let contentPane = $("#testContentPane");
        contentPane.html(markup);
        let showAfterNT = contentPane.find("input.number.showAfter").kendoNumericTextBox({
            min: 500,
            max: 10000,
            value: 500,
            step: 100,
            format: "n0"
        }).data("kendoNumericTextBox");
        showAfterNT.enable(false);
        contentPane.find("input.enable.showAfter").on("click", function () {
            showAfterNT.enable($(this).is(":checked"));
        });
        let autoHideAfterNT = contentPane.find("input.number.autoHideAfter").kendoNumericTextBox({
            min: 0,
            max: 1000000,
            value: 5000,
            step: 100,
            format: "n0"
        }).data("kendoNumericTextBox");
        autoHideAfterNT.enable(false);
        contentPane.find("input.enable.autoHideAfter").on("click", function () {
            autoHideAfterNT.enable($(this).is(":checked"));
        });
        contentPane.find("input.enable.plainText").change(function () {
            if ($(this).is(":checked")) {
                contentPane.find("button[data-type='menuSuccess']").removeAttr("disabled");
                contentPane.find("button[data-type='waiting']").removeAttr("disabled");
            }
            else {
                contentPane.find("button[data-type='menuSuccess']").attr("disabled", "disabled");
                contentPane.find("button[data-type='waiting']").attr("disabled", "disabled");
            }
        });
        contentPane.find("button.showNotification").each((idx, elem) => {
            let $button = $(elem);
            $button.on("click", function () {
                let notificationType = $button.attr("data-type");
                let showAfter;
                if (contentPane.find("input.enable.showAfter").is(":checked")) {
                    let val = showAfterNT.value();
                    if (val > 0)
                        showAfter = val;
                }
                let autoHideAfter;
                if (contentPane.find("input.enable.autoHideAfter").is(":checked"))
                    autoHideAfter = autoHideAfterNT.value();
                let forceCenter = contentPane.find("input.enable.forceCenter").is(":checked");
                let hideOnClick = contentPane.find("input.enable.hideOnClick").is(":checked");
                let plainText = contentPane.find("input.enable.plainText").is(":checked");
                let content;
                if (plainText)
                    content = "Test_" + Utilities_1.synUtil.getGUID(true);
                else {
                    content = $("<img src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAEIUExURUdwTF9fXzQ0NElJSWJiYicnJ0BAQBkZGTAwMJycnAgICGZmZn9/fyEhIVFRUYWFhRUVFU1NTYeHh0dHRyUlJQAAAC0tLUBAQEVFRQAAAKenp/8AAAIAADAwMHAaGgwAAAUEBBMCAhAQEB4eHiMICLIODhYWFgkICEYMDPsGBvMKCvcJCW0ICJsPDygoKDwKChoFBSgJCekKCoIMDNUEBDEJCdgNDe0KCo8PD/4DA8YHB0oWFogFBUpKSsATE6AHB6wMDIQICDUPD6ITEw8PD1UNDb4LCzg4OMsMDF0DA4YQEOAICHgKCj4ICJYCAjo6OtgUFE4HB2EODiEhIfYJCUNDQ20SEi8vL2joVc8AAAAbdFJOUwCAv79Av0C/gEC/v0BAQICAgECAgEC/v7+AQDIhMxcAAAEXSURBVBgZfcAFcsJQFAXQC8VlkHrfaz8R3N217ir730lJBwYS8nNgkTiOwEHgkwV7PZA4yIiPTn/aZr8Pu4J7V+KpQYZ0lW9dMIu4s0qzQGs3Oa7sY8PjTdV6Rdp2d81aACt+rpfzZNUpicwhDDG+JFuN51cY4gpJvKRgGA9J4o1jWFJHJKPEASR5QjLDMYCAyJPMSAXgXpDUhJOANiepvAjgjGckt3AjIQokN9dwqpODGeP3hxwUBHhKTnRwjxx86TjhAcm9q4C/9kgyzVQUQKVdJHtpDmPJo96TrZY4wr9o6oFsdPUQVsKcph39qhbEmle0yKqU9WEjVO+SWZld2BLM5MhkwHsw8WVzF9sUPyxc5ybfWPkDVYNcwcWIkuwAAAAASUVORK5CYII=' />");
                    // content = $("<div style='width: 100; height: 100; border: 1px solid red; padding: 10px;'>abc</div>")
                }
                let options = {};
                if (!hideOnClick)
                    options.hideOnClick = false;
                if (autoHideAfter != undefined && autoHideAfter !== 5000)
                    options.autoHideAfter = autoHideAfter;
                if (forceCenter === true)
                    options.forceCenter = true;
                if (showAfter != undefined)
                    options.showAfter = showAfter;
                if (notificationType === "waiting") {
                    let notificationGuid = $button.attr("data-guid");
                    if (notificationGuid) {
                        Utilities_1.synUtil.Notifications.remove(notificationGuid);
                        $button.removeAttr("data-guid").removeClass("btn-primary");
                    }
                    else {
                        let guid = Utilities_1.synUtil.Notifications[notificationType](content, options, forceCenter);
                        $button.attr("data-guid", guid).addClass("btn-primary");
                    }
                }
                else
                    Utilities_1.synUtil.Notifications[notificationType](content, options, forceCenter);
            });
        });
    });
}
exports.renderTest = renderTest;
